import PropTypes from "prop-types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import IconButton from "@shared/v2/IconButton";
import { StarRegularV6 } from "@shared/v2/Icomoon";

const FeaturedEmptyState = ({ hasLender }) => {
  const { attributes, setNodeRef, transform, transition, isDragging, isOver } = useSortable({
    id: "empty-state",
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    outline: isDragging ? "none" : undefined,
    cursor: "default",
    zIndex: isDragging ? 50 : "auto",
  };

  return (
    <div
      className={`${hasLender ? "tw-min-h-[236px]" : "tw-min-h-[108px]"} ${isOver ? "tw-border-solid tw-border-[1px] tw-border-theme-primary" : ""} tw-flex tw-justify-center tw-items-center tw-gap-[4px]`}
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      Click the{" "}
      <IconButton size="small" schema="tertiary">
        <StarRegularV6 />
      </IconButton>{" "}
      or drag and drop a team member here to feature them!
    </div>
  );
};

FeaturedEmptyState.propTypes = {
  hasLender: PropTypes.bool,
};

FeaturedEmptyState.defaultProps = {
  hasLender: false,
};

export default FeaturedEmptyState;
